var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59811 1.17565C8.35925 -0.39188 10.5584 -0.391883 11.3196 1.17564L12.635 3.88474C12.9373 4.5072 13.5215 4.93865 14.1974 5.03847L17.1388 5.47289C18.8407 5.72425 19.5203 7.8501 18.2888 9.07025L16.1604 11.179C15.6713 11.6635 15.4481 12.3616 15.5636 13.0458L16.066 16.0233C16.3568 17.7462 14.5776 19.0601 13.0553 18.2466L10.4244 16.8408C9.81993 16.5178 9.09775 16.5178 8.49326 16.8408L5.86237 18.2466C4.34009 19.0601 2.56091 17.7462 2.85164 16.0233L3.35409 13.0458C3.46954 12.3616 3.24638 11.6635 2.75733 11.179L0.628895 9.07025C-0.602655 7.8501 0.076927 5.72425 1.77889 5.47289L4.72031 5.03847C5.39616 4.93865 5.98041 4.50721 6.28266 3.88474L7.59811 1.17565Z",
    fill: "#FCB332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.f489a872b6994994f0b9f24796d6656f.svg";
export { ForwardRef as ReactComponent };